const Backofficebff: any = import.meta.env.VITE_BACKOFFICEBFF!;

export const PostCheckoutCommand: any = {
    UpsertBlockedShippingCompanyForCustomer: Backofficebff + '/v1/postcheckout/upsertblockedshippingcompanyforcustomer',
    DeleteBlockedShippingCompanyForCustomer: Backofficebff + '/v1/postcheckout/deleteblockedshippingcompanyforcustomer',
    GetByCustomerIdBlockedShippingCompanyForCustomer:
        Backofficebff + '/v1/postcheckout/getBbycustomeridblockedshippingcompanyforcustomer',
    GetShippingCompanyServiceDistributionListByShippingCompanyIdAndAddressEntityId:
        Backofficebff +
        '/v1/postcheckout/getshippingcompanyservicedistributionlistbyshippingcompanyidandaddressentityid',
    GetShippingCompanyServiceDistributionListByShippingCompanyId:
        Backofficebff + '/v1/postcheckout/getshippingcompanyservicedistributionlistbyshippingcompanyid',
    UpsertShippingCompanyServiceDistribution:
        Backofficebff + '/v1/postcheckout/upsertshippingcompanyservicedistribution',
    UpsertShippingCompanyServiceDistributionFromExcel: Backofficebff + '/v1/postcheckout/upsertdistributionfromexcel',
    UpdateDigitalCardTemplates: Backofficebff + '/v1/postcheckout/update-digital-card-templates',
    DeleteDigitalCardTemplates: Backofficebff + '/v1/postcheckout/delete-digital-card-templates',
    AddDigitalCardTemplates: Backofficebff + '/v1/postcheckout/add-digital-card-templates',
    UpdateDigitalCardDisplayOrder: Backofficebff + '/v1/postcheckout/update-digital-card-display-order',
    ReSendLabelMessage: Backofficebff + '/v1/shipping/resend-label-message',
    GetWaitingForShipments: Backofficebff + '/v1/postcheckout/get-waiting-for-shipments',
    RequestPickupForShipments: Backofficebff + '/v1/postcheckout/request-pickup-for-shipments',
    ListEtbisReports: Backofficebff + '/v1/postcheckout/etbis-reports/list',
    DownloadEtbisReport: Backofficebff + '/v1/postcheckout/etbis-reports/download',
    DeleteEtbisReport: Backofficebff + '/v1/postcheckout/etbis-reports/delete',
};
